$shm_hitalama_map_widget_float_code_html $shm_hitalama_map_widget_float_code
	textarea_hint \html
	code_content /
		<= Textarea $shm_hitalama_map_widget_float_code_textarea
			lazy_enabled <= textarea_lazy_enabled
			hint <= textarea_hint
			sidebar_showed true
			value? <=> code?
			value_click*? <=> widget_value_click*? null
			spellcheck false
			submit <= run_click
			style *
				^
				fontSize <= font_size_px
		<= Bench $shm_hitalama_map_widget_float_code_html_bench
			widget <= widget
			map <= map
			Map_page <= Map_page
			run_click <= run_click
